import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael
 * id 5D87D3E1-C59B-47A2-9ADE-C96FF1C7CA21
 * name format-overline
 * version: 3.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/format-overline.svg
 * tags
 * - Text / Content / Format 
 */
export const FormatOverlineIcon = createSvgIcon(<><path d="M5,5H19V3H5V5M9.62,16L12,9.67L14.37,16M11,7L5.5,21H7.75L8.87,18H15.12L16.25,21H18.5L13,7H11Z" /></>, 'FormatOverlineIcon');
export default FormatOverlineIcon